/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Web_Scraping_Antibot_Title7Inputs */

const en_svc_web_scraping_antibot_title7 = /** @type {(inputs: Svc_Web_Scraping_Antibot_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anti-bot & CAPTCHA resistance`)
};

const ar_svc_web_scraping_antibot_title7 = /** @type {(inputs: Svc_Web_Scraping_Antibot_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مقاومة للحماية من الروبوتات والتحقق CAPTCHA`)
};

const bn_svc_web_scraping_antibot_title7 = /** @type {(inputs: Svc_Web_Scraping_Antibot_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অ্যান্টি-বট ও ক্যাপচা রেজিস্ট্যান্স`)
};

const de_svc_web_scraping_antibot_title7 = /** @type {(inputs: Svc_Web_Scraping_Antibot_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anti-Bot- und CAPTCHA-Resistenz`)
};

const es_svc_web_scraping_antibot_title7 = /** @type {(inputs: Svc_Web_Scraping_Antibot_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resistencia anti-bots y CAPTCHA`)
};

const fr_svc_web_scraping_antibot_title7 = /** @type {(inputs: Svc_Web_Scraping_Antibot_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Résistance anti-bot et CAPTCHA`)
};

const pt_svc_web_scraping_antibot_title7 = /** @type {(inputs: Svc_Web_Scraping_Antibot_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resistência anti-bot e CAPTCHA`)
};

const zh_svc_web_scraping_antibot_title7 = /** @type {(inputs: Svc_Web_Scraping_Antibot_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`反机器人和验证码抵抗`)
};

const tr_svc_web_scraping_antibot_title7 = /** @type {(inputs: Svc_Web_Scraping_Antibot_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anti-bot ve CAPTCHA direnci`)
};

const ru_svc_web_scraping_antibot_title7 = /** @type {(inputs: Svc_Web_Scraping_Antibot_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Защита от ботов и капчи`)
};

const pl_svc_web_scraping_antibot_title7 = /** @type {(inputs: Svc_Web_Scraping_Antibot_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odporność na boty i CAPTCHA`)
};

/**
* | output |
* | --- |
* | "Anti-bot & CAPTCHA resistance" |
*
* @param {Svc_Web_Scraping_Antibot_Title7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_web_scraping_antibot_title7 = /** @type {((inputs?: Svc_Web_Scraping_Antibot_Title7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Web_Scraping_Antibot_Title7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_web_scraping_antibot_title7(inputs)
	if (locale === "bn") return bn_svc_web_scraping_antibot_title7(inputs)
	if (locale === "de") return de_svc_web_scraping_antibot_title7(inputs)
	if (locale === "es") return es_svc_web_scraping_antibot_title7(inputs)
	if (locale === "fr") return fr_svc_web_scraping_antibot_title7(inputs)
	if (locale === "pt") return pt_svc_web_scraping_antibot_title7(inputs)
	if (locale === "zh") return zh_svc_web_scraping_antibot_title7(inputs)
	if (locale === "tr") return tr_svc_web_scraping_antibot_title7(inputs)
	if (locale === "ru") return ru_svc_web_scraping_antibot_title7(inputs)
	if (locale === "pl") return pl_svc_web_scraping_antibot_title7(inputs)
	return en_svc_web_scraping_antibot_title7(inputs)
});
export { svc_web_scraping_antibot_title7 as "svc_web-scraping_ANTIBOT_title" }